/**
 * Specifies the type of price sequence of the return rate.
 * tag: 42736
 * @readonly
 * @enum {number} (int)
 */
export enum ReturnRatePriceSequence {
  /** Initial */
  Initial = 0,
  /** Interim */
  Interim = 1,
  /** Final */
  Final = 2,
}
